export default function scrollToSectionId(id: string) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    element.focus({ preventScroll: true });
  }
}
